import styled from 'styled-components';
import ReviewVideoThumbnail from '../../../assets/images/pluvaIonLanding/review_video_thumbnail.jpg';
import ChevronRightIon from '../../../assets/svg/chevron_right_ion.svg';

const REVIEW_VIDEO_URL =
  'https://market.pluva.kr/info/3c12d1c0-b0dd-4ca7-bec2-c192675a0f56?from=ion';

export const ReviewVideoCtaSection = () => {
  return (
    <Container>
      <Content>
        <ThumbnailLink href={REVIEW_VIDEO_URL}>
          <Thumbnail
            src={ReviewVideoThumbnail}
            alt='고객 인터뷰 - 섬에서도 GPS 연결이 잘 되더라구요'
            loading='lazy'
          />
        </ThumbnailLink>

        <Caption>
          {'* 실사용 고객들의 생생한 후기를 지금 영상으로'}
          <br />
          {'확인해보세요.'}
        </Caption>

        <Eyebrow>{'아이온 실제 고객 사용 후기'}</Eyebrow>

        <Title>
          {'전국에서 검증된'}
          <br />
          {'플루바 아이온'}
        </Title>

        <VideoLink href={REVIEW_VIDEO_URL}>
          {'영상 바로 가기'}
          <Chevron src={ChevronRightIon} alt='' aria-hidden='true' />
        </VideoLink>
      </Content>
    </Container>
  );
};

const Container = styled.section`
  align-self: stretch;

  /* 위 1533-5502 버튼과 좌우 폭을 맞춘다 */
  padding: 0 24px;
  background-color: #000000;
`;

/**
 * 폭이 변해도 구성이 유지돼야 해서 피그마 콘텐츠 영역(288x109.37)을 그대로 비례 확대한다.
 * 288 = 썸네일 좌측 끝부터 타이틀 우측 끝까지로, 이 폭이 위 1533-5502 버튼 폭과 일치한다.
 * --s = 피그마 1px에 해당하는 실제 길이.
 */
const Content = styled.div`
  position: relative;
  container-type: inline-size;
  aspect-ratio: 288 / 109.367;

  --s: 0.3472222cqw;
`;

const ThumbnailLink = styled.a`
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: calc(148 * var(--s));
  height: calc(83.25 * var(--s));
`;

const Thumbnail = styled.img`
  display: block;
  width: 100%;
  height: 100%;

  border-radius: calc(5.076 * var(--s));
  object-fit: cover;
`;

const Caption = styled.p`
  position: absolute;
  left: calc(3.046 * var(--s));
  top: calc(90.722 * var(--s));

  /* 둘째 줄이 "*" 뒤 본문 시작 위치에 맞춰 들여쓰기되도록 */
  padding-left: calc(5.25 * var(--s));
  text-indent: calc(-5.25 * var(--s));

  color: #bbbbbb;
  white-space: nowrap;

  font-family: Pretendard;
  font-size: calc(7.321 * var(--s));
  font-weight: 400;
  line-height: 1.52;
`;

const Eyebrow = styled.p`
  position: absolute;
  left: calc(165 * var(--s));
  top: calc(1.91 * var(--s));

  white-space: nowrap;

  font-family: Pretendard;
  font-size: calc(9.92 * var(--s));
  font-weight: 600;
  line-height: 1.3;

  background: linear-gradient(90deg, #eeeeee 0%, #68cde4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Title = styled.h2`
  position: absolute;
  left: calc(165 * var(--s));
  top: calc(20.541 * var(--s));

  color: #ffffff;
  white-space: nowrap;

  font-family: Pretendard;
  font-size: calc(20.214 * var(--s));
  font-weight: 800;
  line-height: 1.26;
  letter-spacing: calc(-0.3675 * var(--s));
`;

const VideoLink = styled.a`
  position: absolute;
  left: calc(166 * var(--s));
  top: calc(88.528 * var(--s));
  width: calc(78.311 * var(--s));

  color: #82b1bc;
  text-decoration: none;
  white-space: nowrap;

  font-family: Pretendard;
  font-size: calc(12.186 * var(--s));
  font-weight: 600;
  line-height: calc(16.772 * var(--s));
  letter-spacing: calc(-0.2437 * var(--s));
`;

const Chevron = styled.img`
  position: absolute;
  left: calc(73.55 * var(--s));
  top: calc(4.761 * var(--s));
  width: calc(4.7618 * var(--s));
  height: calc(8.9008 * var(--s));
`;
